
import { defineComponent, onMounted, ref, onBeforeUpdate } from 'vue'
import { useStore } from '@/store/index'
import { useRoute } from 'vue-router'
import { axios, ApiResponse } from '@/plugins/axios'
import LayoutsAuth from '@/layouts/Auth.vue'
import { PageAttributes } from '@/types/models/page'
import LayoutsAuthWidth from '@/layouts/AuthWidth.vue'

export default defineComponent({
  components: { LayoutsAuth, LayoutsAuthWidth },
  setup() {
    const store = useStore()
    const route = useRoute()
    const page = ref<PageAttributes | undefined>()

    const initialize = () => {
      axios
        .get<ApiResponse<PageAttributes>>(`/page/${route.params.page_id}`)
        .then(response => {
          page.value = response.data.payload
        })
    }

    onBeforeUpdate(() => {
      initialize()
    })

    onMounted(() => {
      initialize()
    })

    return {
      store,
      page
    }
  },
})
